<main class="d-flex flex-column h-100" *ngIf="(store$ | async) as store">
  <ng-header-summary
    [config]="inventoryConfig"
    (monitorDate)="dispatchLoadAccessorial($event)"
  ></ng-header-summary>
  <mat-tab-group class="ns-mat-tab-group h-100 overflow-auto"
                 (selectedTabChange)="updateSummary($event)"
                 #matTabGroup>
    <mat-tab label="INTRA-PLANT SWITCH">
      <ng-accessorial-inventory
        [loading]="store.state.loading"
        [type]="store.type"
        [data]="store.state.intraPlants"
        [name]="gridType.INTRA_PLANT_SWITCH"
        [printTitle]="printTitle"
      ></ng-accessorial-inventory>
    </mat-tab>
    <mat-tab label="INTRA-TERMINAL SWITCH">
      <ng-accessorial-inventory
        [loading]="store.state.loading"
        [type]="store.type"
        [data]="store.state.intraTerminals"
        [name]="gridType.INTRA_TERMINAL_SWITCH"
        [printTitle]="printTitle"
      ></ng-accessorial-inventory>
    </mat-tab>
    <mat-tab label="PULL TURN">
      <ng-accessorial-inventory
        [loading]="store.state.loading"
        [type]="store.type"
        [data]="store.state.pullTurns"
        [name]="gridType.PULL_TURN"
        [printTitle]="printTitle"
      ></ng-accessorial-inventory>
    </mat-tab>
    <mat-tab label="PULL WEIGHT">
      <ng-accessorial-inventory
        [loading]="store.state.loading"
        [type]="store.type"
        [data]="store.state.pullWeights"
        [name]="gridType.PULL_WEIGHT"
        [printTitle]="printTitle"
      ></ng-accessorial-inventory>
    </mat-tab>
    <mat-tab label="ORDER NOT USED">
      <ng-accessorial-inventory
        [loading]="store.state.loading"
        [type]="store.type"
        [data]="store.state.unusedOrders"
        [name]="gridType.ORDER_NOT_USED"
        [printTitle]="printTitle"
      ></ng-accessorial-inventory>
    </mat-tab>
    <mat-tab label="CHARGEABLE REASON CODE">
      <ng-accessorial-inventory
        [loading]="store.state.loading"
        [type]="store.type"
        [data]="store.state.chargeableCodes"
        [name]="gridType.CHARGEABLE_REASON_CODE"
        [printTitle]="printTitle"
      ></ng-accessorial-inventory>
    </mat-tab>
    <mat-tab label="LATE SURRENDER">
      <ng-accessorial-inventory
        [loading]="store.state.loading"
        [type]="store.type"
        [data]="store.state.lateSurrenders"
        [name]="gridType.LATE_SURRENDER"
        [printTitle]="printTitle"
      ></ng-accessorial-inventory>
    </mat-tab>
    <mat-tab label="LEASE TRACK OVERAGES" *ngIf="store.authorizations?.canViewLeaseTracks">
      <ng-lease-track-overage-container [type]="store.type" [printTitle]="printTitle"></ng-lease-track-overage-container>
    </mat-tab>
  </mat-tab-group>
</main>
